import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { Divider } from 'grab-ui';

import {
  absAmount,
  formatPrice,
  isNegativeAmount,
} from 'common/utils/currency';
import {
  PICKING_UP,
  DROPPING_OFF,
  FAILED_DELIVERY,
  RETURNED,
} from 'constants/new-order-status';
import PayOnDeliveryItem from '../pod-item/pod-item';
import styles from './pod-ongoing-details.less';

const PodOngoingDetails = ({ status, userType, symbol, payOnDelivery }) => {
  const { isSender, isReceiver } = userType;
  const show =
    !!payOnDelivery &&
    payOnDelivery.items &&
    payOnDelivery.items.length &&
    ((isSender && status === PICKING_UP) ||
      (isReceiver && status === DROPPING_OFF) ||
      (isReceiver && status === FAILED_DELIVERY) ||
      status === RETURNED);
  if (!show) return null;

  const { items = [], totalAmount } = payOnDelivery;

  return (
    <div className={styles.container}>
      <p className={styles.headerTitle}>{I18n.t('paymentDetails.title')}</p>

      {items
        .filter(item => !!parseFloat(item.amount))
        .map(item => (
          <PayOnDeliveryItem
            key={item.type}
            item={item}
            symbol={symbol}
            cashlessPaymentCompleted={payOnDelivery.cashlessPaymentCompleted}
          />
        ))}

      {!!parseFloat(totalAmount) && (
        <Fragment>
          <Divider className={styles.divider} />
          <div className={styles.transaction}>
            <div className={styles.titleContainer}>
              <p className={styles.title}>
                {isNegativeAmount(totalAmount)
                  ? I18n.t('paymentDetails.totalToCollect')
                  : I18n.t('paymentDetails.total')}
              </p>
            </div>

            <p data-testid="total-amount" className={styles.total}>
              {formatPrice({ amount: absAmount(totalAmount), symbol })}
            </p>
          </div>
        </Fragment>
      )}
    </div>
  );
};

PodOngoingDetails.propTypes = {
  status: PropTypes.string,
  userType: PropTypes.shape({
    isReceiver: PropTypes.bool,
    isSender: PropTypes.bool,
  }),
  symbol: PropTypes.string,
  payOnDelivery: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string,
        amount: PropTypes.string,
        paymentMethod: PropTypes.string,
      }),
    ),
    totalAmount: PropTypes.string,
    totalCashAmount: PropTypes.string,
    totalCashlessAmount: PropTypes.string,
  }),
};

PodOngoingDetails.defaultProps = {
  status: '',
  userType: {
    isSender: false,
    isReceiver: true,
  },
  symbol: '',
  payOnDelivery: {
    items: [],
    totalAmount: '',
    totalCashAmount: '',
    totalCashlessAmount: '',
  },
};

export default PodOngoingDetails;
